module.exports = __webpack_public_path__ + "img/3.bbd78548.jpg";